import type { Completable, OnError, OnLoad } from '../../types';

export function waitForAllResources<T1, T2, T3, T4, T5, T6, T7, T8, T9, T10>(
	resources: [
		Completable<T1>,
		Completable<T2>,
		Completable<T3>,
		Completable<T4>,
		Completable<T5>,
		Completable<T6>,
		Completable<T7>,
		Completable<T8>,
		Completable<T9>,
		Completable<T10>,
	],
): Completable<[T1, T2, T3, T5, T6, T7, T9, T10]>;

export function waitForAllResources<T1, T2, T3, T4, T5, T6, T7, T8, T9>(
	resources: [
		Completable<T1>,
		Completable<T2>,
		Completable<T3>,
		Completable<T4>,
		Completable<T5>,
		Completable<T6>,
		Completable<T7>,
		Completable<T8>,
		Completable<T9>,
	],
): Completable<[T1, T2, T3, T5, T6, T7, T9]>;

export function waitForAllResources<T1, T2, T3, T4, T5, T6, T7, T8>(
	resources: [
		Completable<T1>,
		Completable<T2>,
		Completable<T3>,
		Completable<T4>,
		Completable<T5>,
		Completable<T6>,
		Completable<T7>,
		Completable<T8>,
	],
): Completable<[T1, T2, T3, T5, T6, T7, T8]>;

export function waitForAllResources<T1, T2, T3, T4, T5, T6, T7>(
	resources: [
		Completable<T1>,
		Completable<T2>,
		Completable<T3>,
		Completable<T4>,
		Completable<T5>,
		Completable<T6>,
		Completable<T7>,
	],
): Completable<[T1, T2, T3, T5, T6, T7]>;

export function waitForAllResources<T1, T2, T3, T4, T5, T6>(
	resources: [
		Completable<T1>,
		Completable<T2>,
		Completable<T3>,
		Completable<T4>,
		Completable<T5>,
		Completable<T6>,
	],
): Completable<[T1, T2, T3, T5, T6]>;

export function waitForAllResources<T1, T2, T3, T4, T5>(
	resources: [Completable<T1>, Completable<T2>, Completable<T3>, Completable<T4>, Completable<T5>],
): Completable<[T1, T2, T3, T5]>;

export function waitForAllResources<T1, T2, T3, T4>(
	resources: [Completable<T1>, Completable<T2>, Completable<T3>, Completable<T4>],
): Completable<[T1, T2, T3, T4]>;

export function waitForAllResources<T1, T2, T3>(
	resources: [Completable<T1>, Completable<T2>, Completable<T3>],
): Completable<[T1, T2, T3]>;

export function waitForAllResources<T1, T2>(
	resources: [Completable<T1>, Completable<T2>],
): Completable<[T1, T2]>;

export function waitForAllResources<T extends Completable<unknown>[]>(
	resources: T,
): Completable<{
	[K in keyof T]: T[K] extends Completable<infer U> ? U : never;
}>;

export function waitForAllResources(resources: Completable<any>[]): Completable<any> {
	return {
		onComplete(onLoad: OnLoad<any[]>, onError?: OnError) {
			const cleanups: (() => void)[] = [];
			const values = new Array(resources.length);
			let completed = false;

			const dispose = () => {
				cleanups.forEach((cleanup) => cleanup());
				cleanups.length = 0;
			};

			const done = () => {
				dispose();
				completed = true;
			};

			let loadedResources = 0;
			for (let i = 0; i < resources.length && !completed; i++) {
				const completable = resources[i];

				cleanups.push(
					completable.onComplete(
						(value) => {
							values[i] = value;
							loadedResources++;
							if (loadedResources === resources.length) {
								onLoad(values);
								done();
							}
						},
						(error: Error) => {
							onError?.(error);
							done();
						},
					),
				);
			}

			return dispose;
		},
	};
}
